module.exports = __webpack_public_path__ + "static/media/fid195168le.da73a143.svg";